import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSolletWallet(),
      getMathWallet(),
    ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button">
          <img src="/icons/close.svg" alt="" onClick={toggleMenu} />
        </div>
        <ul>
          <li>
            <img className="mobile-nav-logo" src="/img/logo.png" alt="" />
          </li>
          <li>
            <a href="/#mint" onClick={toggleMenu}>
              MINT
            </a>
          </li>

          <li>
            <a href="/#Access" onClick={toggleMenu}>
              Access
            </a>
          </li>
          <li>
            <a href="/#faq" onClick={toggleMenu}>
              FAQ
            </a>
          </li>
          <li>
            <div className="social-icons">
              <a href="https://twitter.com/BenjaminsSol" target="_blank" rel="noreferrer">
                <img className="nav-social" src="/icons/twitter.svg" alt="" />
              </a>
              <a href="https://discord.com/invite/Yw8sG2tKGN" target="_blank" rel="noreferrer">
                <img className="nav-social" src="/icons/discord.svg" alt="" />
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <img className="nav-logo" src="/img/logo.png" alt="" />
          <a className="hide-800" href="/#mint">
            Mint
          </a>
          <a className="hide-800" href="/#Access">
            Access
          </a>
          <a className="hide-800" href="/#faq">
            FAQ
          </a>
          <div className="social-icons hide-800">
            <a href="https://twitter.com/BenjaminsSol" target="_blank" rel="noreferrer">
              <img className="nav-social" src="/icons/twitter.svg" alt="" />
            </a>
            <a href="https://discord.com/invite/Yw8sG2tKGN" target="_blank" rel="noreferrer">
              <img className="nav-social" src="/icons/discord.svg" alt="" />
            </a>
          </div>
        </div>
      </nav>
      <div className="content-wrapper">
        <header className="card" id="Mint">
          <div style={{ padding: "0 24px 0 24px 0" }}>
            <h3 className="text-secondary-color">Welcome To</h3>
            <h1 className="pb-3">
              The Benjamin Key Mint</h1>
            <p className="text-secondary-color">
            Benjamin SOL aka "Solana's C-Note" are 3 unique collections of vibing Benjamin Franklin NFTs, coming to the Solana blockchain!

​
These assets will provide lucrative benefits to holders in a variety of ways
            </p>
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets} autoConnect>
                  <WalletDialogProvider>
                    <Minter
                      candyMachineId={candyMachineId}
                      connection={connection}
                      startDate={startDateSeed}
                      txTimeout={txTimeout}
                      rpcHost={rpcHost}
                    />
                  </WalletDialogProvider>
                </WalletProvider>
              </ConnectionProvider>
            </ThemeProvider>
          </div>
        </header>

        <div id="link2" className="container">


        </div>

        <div id="Access" className="container card">
 
          <h1 className="pb-3">What are the key-holders going to access?</h1>
   
          <b style={{textAlign:"justify"} }className="text-secondary-color"> Benjamins KEY is going to be our first NFT-collection and it will be the rarest and most lucrative one aswell.
Holders will be able to access the future DAO and the Alpha Group, DAO-members will be generating passive income through the DAO-fund.
We will be doing polls on what blue chip projects we should invest into as a DAO-fund. It could either be HODL-to-Earn projects like DazedDucks and Stoned Apes or other Blue Chips such as Pesky Penguins and SOLpunks.
We will also be minting projects on different launchpads using a mintbot where we have partnered up with! It all depends on the DAO-votes! It will be generating passive income for our DAO-members and generating long-term utility aswell in terms of future benefits!
In the future, between when our Main Collection “Benjamins” and “The Benjamin Kites” drops, we will be introducing staking. Benjamins KEY holders are going to gain extra staking % in the future aswell, when staking gets introduced.</b>


</div>


        <div id="faq" className="container faq">
          <h1 style={{ padding: "0 0 24px 0" }}>FAQ</h1>
          <div>
            <h4>What happens when we sell the NFTs owned by the DAO?</h4>
            <p>
            Our exit-plan in terms of selling the NFTs owned by the DAO, is going to be distributing 80% of the profits BACK to the KEY-holders. 20% will go to our future Staking Pool. Nothing will go to the team! 
            That will certainly boost the rarity behind our Benjamins KEY since the supply is 170. 

            </p>

            <hr />
          </div>

          <div>
            <h4>How are we going to distribute our mint-revenue?</h4>
            <p>
            60% of mint-revenue will directly go into the DAO-fund. That is 60% payback.
            30% of mint revenue will go to the whole team.
            10% of the mint-revenue will go to marketing.
            </p>

            <hr />
          </div>

          <div>
            <h4>How are we going to distribute artist-royalties?</h4>
            <p>
            We will be having 5% artist royalties on Benjamins KEY secondary marketplaces!
            80% will go to the team!
            20% will go to the DAO-fund!
            </p>

            <hr />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
